/* eslint-disable import/prefer-default-export */
import axios from 'axios';

export const changeTrack = (track) =>
  axios
    .post('/member_self_serve/set_track', {
      track,
    })
    .then(() => {
      window.location.reload();
    });
